// extracted by mini-css-extract-plugin
export var csatScore = "_ie-5";
export var header = "_ie-1";
export var panelWrapper = "_ie-2";
export var postPreview = "_ie-3";
export var rightContent = "_ie-0";
export var wrappingText = "_ie-4";